import { constructionApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';

import { mapConstructionBudget, mapDrawRequest, mapDrawRequests } from '../construction.mappers';
import { CONSTRUCTION_ACTION_TYPE } from '../types';

export const getConstructionBudgetAction = catchAsyncActionError(
  ({ applicationId, signal } = {}) =>
    async dispatch => {
      const { data } = await constructionApi.getBudget({ applicationId, signal });

      return dispatch({
        type: CONSTRUCTION_ACTION_TYPE.GET_BUDGET,
        payload: mapConstructionBudget(data),
        meta: { applicationId },
      });
    },
);

// A loan with no budget yet POSTs a new ConstructionBudgetDto (201); an existing budget PUTs the full
// DTO back (200). Both land in the same SAVE_BUDGET slice, so the drawer selects the verb via isCreate.
export const saveConstructionBudgetAction = catchAsyncActionError(
  ({ applicationId, payload, isCreate = false, signal } = {}) =>
    async dispatch => {
      const { data } = isCreate
        ? await constructionApi.createBudget({ applicationId, payload, signal })
        : await constructionApi.saveBudget({ applicationId, payload, signal });

      return dispatch({
        type: CONSTRUCTION_ACTION_TYPE.SAVE_BUDGET,
        payload: mapConstructionBudget(data),
        meta: { applicationId },
      });
    },
);

export const getDrawRequestsAction = catchAsyncActionError(
  ({ applicationId, signal } = {}) =>
    async dispatch => {
      const { data } = await constructionApi.getDrawRequests({ applicationId, signal });

      return dispatch({
        type: CONSTRUCTION_ACTION_TYPE.GET_DRAW_REQUESTS,
        payload: mapDrawRequests(data),
        meta: { applicationId },
      });
    },
);

export const createDrawRequestAction = catchAsyncActionError(
  ({ applicationId, payload, signal } = {}) =>
    async dispatch => {
      const { data } = await constructionApi.createDrawRequest({ applicationId, payload, signal });

      return dispatch({
        type: CONSTRUCTION_ACTION_TYPE.CREATE_DRAW_REQUEST,
        payload: mapDrawRequest(data),
        meta: { applicationId },
      });
    },
);

export const decideDrawRequestAction = catchAsyncActionError(
  ({ applicationId, drawRequestId, payload, signal } = {}) =>
    async dispatch => {
      const { data } = await constructionApi.decideDrawRequest({
        applicationId,
        drawRequestId,
        payload,
        signal,
      });

      return dispatch({
        type: CONSTRUCTION_ACTION_TYPE.DECIDE_DRAW_REQUEST,
        payload: mapDrawRequest(data),
        meta: { applicationId },
      });
    },
);

export const clearConstructionAction = ({ applicationId } = {}) => ({
  type: CONSTRUCTION_ACTION_TYPE.CLEAR,
  meta: { applicationId },
});
